module.exports = __webpack_public_path__ + "img/training_ranking.29d195c9.png";